import { FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CryptoJS from 'crypto-js';
const secretKey = 'allloverthebridge415998Hu08Da270901';

export default function ViewQuestionBank() {
    const [data, setData] = useState([]);
    const [set, setSet] = useState('');
    const [selectedSetId, setSelectedSetId] = useState('');
    const [setOptions, setSetOptions] = useState([]);
    const [level, setLevel] = useState('');
    const [selectedLevelId, setSelectedLevelId] = useState('');
    const [levelOptons, setLevelOptions] = useState([]);
    const [sClass, setSClass] = useState('');
    const [selectedClassId, setSelectedClassId] = useState('');
    const [classOptons, setClassOptions] = useState([]);
    const [subject, setSubject] = useState('');
    const [selectedSubjectId, setSelectedSubjectId] = useState('');
    const [subjectOptons, setSubjectOptions] = useState([]);
    const [DeleteId, setDeleteId] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [failureMessage, setFailureMessage] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Dashboard', url: '/Dashboard' }]);
    const location = useLocation();
    const navigate = useNavigate();

    const handleSetChange = (e) => {
        const selectedValue = e.target.value
        setSet(selectedValue)
        const selectedSet = setOptions.find(option => option.name === selectedValue);
        if (selectedSet) {
            setSelectedSetId(selectedSet.id)
        }
    };

    const handleLevelChange = (e) => {
        const selectedValue = e.target.value
        setLevel(selectedValue)
        const selectedLevel = levelOptons.find(option => option.name === selectedValue);
        if (selectedLevel) {
            setSelectedLevelId(selectedLevel.id)
        }
    };

    const handleSClassChange = (e) => {
        const selectedValue = e.target.value
        setSClass(selectedValue)
        const selectedClasses = classOptons.find(option => option.name === selectedValue);
        if (selectedClasses) {
            setSelectedClassId(selectedClasses.id)
        }
        setSubject('');
        setSelectedSubjectId('');
    };

    const handleSubjectChange = (e) => {
        const selectedValue = e.target.value
        setSubject(selectedValue)
        const selectedSubject = subjectOptons.find(option => option.name === selectedValue);
        if (selectedSubject) {
            setSelectedSubjectId(selectedSubject.id)
        }
    };

    useEffect(() => {
        const fetchSet = async () => {
            try {
                const response = await fetch(`/api/getSetName`);
                if (response.ok) {
                    const data = await response.json();
                    const filteredOptions = data.recordset.filter(option => option.SetName !== null).map(option => ({
                        name: option.SetName,
                        id: option.SEID,
                    }));
                    setSetOptions(filteredOptions);
                } else {
                    console.error('Error fetching options');
                }
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        };
        const fetchElevel = async () => {
            try {
                const response = await fetch(`/api/getExamLevels`);
                if (response.ok) {
                    const data = await response.json();
                    const filteredOptions = data.recordset.filter(option => option.SetName !== null).map(option => ({
                        name: option.DLevel,
                        id: option.DLID,
                    }));
                    setLevelOptions(filteredOptions);
                } else {
                    console.error('Error fetching options');
                }
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        };
        const fetchClass = async () => {
            try {
                const response = await fetch(`/api/getClasses`);
                if (response.ok) {
                    const data = await response.json();
                    const filteredOptions = data.recordset.filter(option => option.Class !== null).map(option => ({
                        name: option.Class,
                        id: option.CLID,
                        min: option.MinAge,
                        max: option.MaxAge
                    }));
                    setClassOptions(filteredOptions);
                } else {
                    console.error('Error fetching options');
                }
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        };
        const fetchSubject = async () => {
            try {
                const response = await fetch(`/api/getSubjectByClass/${selectedClassId}`);
                if (response.ok) {
                    const data = await response.json();
                    const filteredOptions = data.recordset.filter(option => option.Subject !== null).map(option => ({
                        name: option.Subject,
                        id: option.SBID,
                    }));
                    setSubjectOptions(filteredOptions);
                } else {
                    console.error('Error fetching options');
                }
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        };

        fetchSet();
        fetchElevel();
        fetchClass();
        if (selectedClassId) {
            fetchSubject();
        }
    }, [selectedClassId]);

    const removeSuccessMessage = () => {
        setSuccessMessage('');
        setShowModal(false);
    };

    const handleReset = () => {
        setSet('');
        setSelectedSetId([]);
        setLevel('');
        setSelectedLevelId([]);
        setSClass('');
        setSelectedClassId([]);
        setSubject('');
        setSelectedSubjectId([]);
    };

    const fetchSubjects = useCallback(async () => {
        try {
            const response = await fetch(`/api/getFilteredQuestionDetails`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ selectedSetId, selectedLevelId, selectedClassId, selectedSubjectId }),
            });

            if (response.ok) {
                const filteredData = await response.json();
                setData(filteredData);
            } else {
                console.error('Error fetching filtered data');
            }
        } catch (error) {
            console.error('Error fetching filtered data:', error);
        }
    }, [selectedSetId, selectedLevelId, selectedClassId, selectedSubjectId]);

    useEffect(() => {
        fetchSubjects();
    }, [fetchSubjects]);

    const encryptId = (QBID, secretKey) => {
        const encrypted = CryptoJS.AES.encrypt(QBID.toString(), secretKey).toString();
        const urlSafeBase64 = encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        return urlSafeBase64;
    };

    const handleEditClick = (QBID) => {
        const encrypteQBID = encryptId(QBID, secretKey);
        navigate(`/CreateQuestionBank/${encodeURIComponent(encrypteQBID)}?Type=QuestionBank`)
    };

    const handleViewFormat = (QBID) => {
      const encrypteQBID = encryptId(QBID, secretKey);
      navigate(`/QuestionFormat/${encodeURIComponent(encrypteQBID)}?Type=QuestionBank`)
    };

    const handleConfirmation = async (QBID) => {
        setIsDeleted(true);
        setDeleteId(QBID)
    };

    const handleCancel = async () => {
        setIsDeleted(false);
        setDeleteId('')
    };

    const handleDelete = async (QBID) => {
        try {
            const response = await fetch(`/api/DeleteQuestions/${QBID}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                setData((prevData) => prevData.filter(item => item.QBID !== QBID));
                const Data = await response.json();
                setIsDeleted(false)
                setShowModal(true);
                setFailureMessage('');
                setSuccessMessage(Data.message);
                setTimeout(() => {
                    removeSuccessMessage();
                }, 2000);
                DeleteId('');
            } else {
                const Data = await response.json();
                setIsDeleted(false);
                setShowModal(true);
                setSuccessMessage('');
                setFailureMessage(Data.error);
                setTimeout(() => {
                    removeSuccessMessage();
                }, 2000);
            }
        } catch (error) {
            console.error('Error deleting Class:', error);
        }
    };

    useEffect(() => {
        const currentRoute = location.pathname;
        const newBreadcrumbs = generateBreadcrumbs(currentRoute);
        setBreadcrumbs(newBreadcrumbs);
    }, [location]);

    const generateBreadcrumbs = (currentRoute) => {
        const breadcrumbsArray = [{ label: 'Dashboard', url: '/Dashboard' }];

        const routeParts = currentRoute.split('/').filter(Boolean);
        let urlSoFar = '';
        routeParts.forEach((part) => {
            urlSoFar += `/${part}`;
            breadcrumbsArray.push({ label: part, url: urlSoFar });
        });

        return breadcrumbsArray;
    };

    return (
        <>
            {showModal && (
                <div className="modal-backdrop show"></div>
            )}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
                        <div className="modal-header">
                            <h5 className="modal-title">Success Message</h5>
                        </div>
                        <div className="modal-body">
                            {successMessage && <p className='text-success'>{successMessage}</p>}
                            {failureMessage && <p className='text-danger'>{failureMessage}</p>}
                        </div>
                    </div>
                </div>
            </div>

            <div className='my-2 mobile-margin mx-2'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {breadcrumbs.map((breadcrumb, index) => (
                            <li key={index} className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}>
                                {index === breadcrumbs.length - 1 ? (
                                    breadcrumb.label
                                ) : (
                                    <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>

                <div className='shadow-sm p-3 mb-3 bg-white rounded'>
                    <div className='row d-flex align-items-center'>
                        <div className='col-3 col-md-1 mb-2'>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Set</InputLabel>
                                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={set} onChange={handleSetChange}>
                                    {setOptions.map((option, index) => (
                                        <MenuItem key={index} value={option.name}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-3 col-md-2 mb-2'>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Level</InputLabel>
                                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={level} onChange={handleLevelChange}>
                                    {levelOptons.map((option, index) => (
                                        <MenuItem key={index} value={option.name}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-3 col-md-2 mb-2'>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Class</InputLabel>
                                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={sClass} onChange={handleSClassChange}>
                                    {classOptons.map((option, index) => (
                                        <MenuItem key={index} value={option.name}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-3 col-md-2 mb-2'>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Subject</InputLabel>
                                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={subject} onChange={handleSubjectChange}>
                                    {subjectOptons.map((option, index) => (
                                        <MenuItem key={index} value={option.name}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-6 col-md-2'>
                            <Button variant="contained" color="secondary" fullWidth onClick={handleReset}>Reset</Button>
                        </div>
                        <div className='col-6 col-md-3'>
                            <Button variant="contained" color="primary" fullWidth onClick={() => navigate(`/CreateQuestionBank?Type=QuestionBank`)} >Add Question Bank</Button>
                        </div>
                    </div>
                </div>

                <div className='shadow mb-5 rounded' style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                    <table className='table table-nowrap table-striped mb-0 mt-0'>
                        <thead className='table-primary' style={{ position: 'sticky', top: '0', zIndex: '1', marginTop: '1rem' }}>
                            <tr>
                                <th>#</th>
                                <th>Difficulty Level</th>
                                <th>Question</th>
                                <th>Set</th>
                                <th>View</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.DLevel}</td>
                                    <td><ReactQuill modules={{ toolbar: false }} value={item.Question} readOnly={true} className="no-border-quill"/></td>
                                    <td>{item.SetName}</td>
                                    <td><p className='badge badge-info-lighten' onClick={() => handleViewFormat(item.QBID)}><i className="bi bi-clipboard-check-fill fs-6"></i></p></td>
                                    <td><p className='badge badge-warning-lighten' onClick={() => handleEditClick(item.QBID)}><i className="bi bi-pencil-square fs-6"></i></p></td>
                                    <td><p className='badge badge-danger-lighten mx-2' onClick={() => handleConfirmation(item.QBID)}><i className="bi bi-trash-fill fs-6"></i></p></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {isDeleted && (
                    <div className="modal-backdrop show"></div>
                )}
                <div className={`modal fade ${isDeleted ? 'show' : ''}`} style={{ display: isDeleted ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete <strong>Question?</strong></h5>
                            </div>
                            <div className="modal-body">
                                <p>This Will Delete Question <span className='text-danger'>Permannently</span></p>
                                <div className='d-flex flex-row-reverse '>
                                    <button className='btn btn-danger mx-2' onClick={() => handleDelete(DeleteId)}>Delete</button>
                                    <button className='btn btn-secondary mx-2' onClick={handleCancel}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

